module.exports = __webpack_public_path__ + "img/clerk_accounting_2.37714ae3.png";